var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolPolygonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11.828 3.514 3.6 19.972h16.457zm0 2.236-6.61 13.221h13.22z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.996 5.229a2.229 2.229 0 1 1-4.457 0 2.229 2.229 0 0 1 4.457 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11.767 6.457a1.229 1.229 0 1 0 0-2.457 1.229 1.229 0 0 0 0 2.457m0 1a2.229 2.229 0 1 0 0-4.457 2.229 2.229 0 0 0 0 4.457",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.371 18.771a2.229 2.229 0 1 1-4.457 0 2.229 2.229 0 0 1 4.457 0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.143 20a1.229 1.229 0 1 0 0-2.457 1.229 1.229 0 0 0 0 2.457m0 1a2.229 2.229 0 1 0 0-4.457 2.229 2.229 0 0 0 0 4.457",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.084 18.771a2.229 2.229 0 1 1-4.457 0 2.229 2.229 0 0 1 4.457 0"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.856 20a1.229 1.229 0 1 0 0-2.457 1.229 1.229 0 0 0 0 2.457m0 1a2.229 2.229 0 1 0 0-4.457 2.229 2.229 0 0 0 0 4.457",
  clipRule: "evenodd"
})));
export default SvgToolPolygonIcon;